/* eslint-disable @typescript-eslint/no-unused-vars */
import Icon from "hardcover-ui/components/Icon";
import Text from "hardcover-ui/components/Text";
import { CurrentlyReadingStatus } from "components/shared/UserBookStatuses";
import { ReadingJournalEventProps } from "./types";

export default function StatusCurrentlyreading({
  journal,
}: ReadingJournalEventProps) {
  return (
    <Text variant="secondary" className="flex flex-row items-center gap-2">
      <Icon icon={CurrentlyReadingStatus.icon} />
      <span>Started Reading</span>
    </Text>
  );
}
